module.exports = __webpack_public_path__ + "img/aave.e2e71009.svg";